// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"0e0d54a0","378":"2e019c79","431":"540f7a92","453":"99dcf01f","784":"ba3c7114","945":"44b463be"}[chunkId] + ".chunk.js";
};